<template>
  <div class="login flex justify-center items-start pt-20 min-h-screen">
    <Card class="w-[400px]">

      <CardHeader>
        <CardTitle>{{ $t(`auth.${setPasswordType}.enter-phone.title`) }}</CardTitle>
        <CardDescription v-html="$t(`auth.${setPasswordType}.enter-phone.text`)"></CardDescription>
      </CardHeader>

      <CardContent>
        <form @submit.prevent="sendOTPRequest" class="flex flex-col gap-y-6">
          <div class="flex flex-col space-y-1.5">
            <Label for="phone">
              {{ $t(`auth.${setPasswordType}.enter-phone.fields.phone.title`) }}
            </Label>

            <Input
                id="phone"
                type="tel"
                v-model="phone"

                placeholder="+380XX XXX XX XX"

                :class="{'border-red-500': errors.phone}"
                class="focus:outline-none focus-visible:ring-0 focus-visible:border-black"
                @input="sanitizePhoneInput"
            />
            <p v-if="errors.phone" class="text-sm text-red-500">{{ errors.phone }}</p>
          </div>

        </form>
      </CardContent>

      <CardFooter class="px-6 pt-0">
        <Button
            class="w-full bg-[#64748B] transition-colors hover:bg-[#64748B] hover:opacity-75"
            :disabled="isDataLoading || !isPhoneValid"
            @click.prevent="sendOTPRequest"
        >
          <span v-if="isDataLoading">Відправка...</span>
          <span v-else>{{ $t(`auth.${setPasswordType}.enter-phone.actions.continue`) }}</span>
        </Button>
      </CardFooter>

    </Card>
  </div>
</template>

<script>
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

import { UserApi } from '@js-app/office/api/user-api'
import { RESET_PASSWORD_STEP } from '@vue-app/store/const/actions-types'
import {toast} from "vue-sonner";
import { getCurrentInstance } from 'vue';
const instance = getCurrentInstance()
const t = (key) => instance?.ctx.$i18n.t(key)

export default {
  name: 'EnterPhone',
  components: {
    Button,
    Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle,
    Input,
    Label
  },
  props: {
    hash: String,
  },
  data() {
    return {
      phone: '+380',
      isDataLoading: false,
      errors: {
        phone: null,
        general: null,
      }
    }
  },

  PHONE_MASK: '+XXXXX XXX XX XX',
  computed: {
    setPasswordType() {
      return this.$route.meta.setPasswordType || 'forgot-password'
    },
    isPhoneValid() {
      const cleanPhone = this.phone.replace(/[^\d+]/g, '');
      return cleanPhone.length === 13 && cleanPhone.startsWith('+380');
    }
  },
  created() {
    this.$store.dispatch(RESET_PASSWORD_STEP, {
      id: 'phone',
      hash: this.hash,
      type: this.setPasswordType,
    })
  },
  methods: {
    sanitizePhoneInput() {
      let sanitized = this.phone.replace(/[^\d+]/g, '');
      if (sanitized.length > 13) {
        sanitized = sanitized.substring(0, 13);
      }

      this.phone = sanitized;
      this.errors.phone = null;
    },

    validateForm() {
      this.errors.phone = null;
      let isValid = true;

      if (!this.phone || this.phone.replace(/\D/g, '').length < 1) {
        this.errors.phone = 'Введіть номер телефону.';
        isValid = false;
      } else if (!this.isPhoneValid) {
        this.errors.phone = 'Введіть коректний номер';
        isValid = false;
      }

      return isValid;
    },

    async sendOTPRequest() {
      if (!this.validateForm()) {
        return;
      }

      this.isDataLoading = true
      this.errors.general = null;

      try {
        let sendOTPResponse = await UserApi.sendResetPasswordOTP(
            this.hash,
            this.phone
        )

        await this.$store.dispatch(RESET_PASSWORD_STEP, {
          id: 'otp',
          phoneMask: sendOTPResponse.data.phone_mask,
        })

        await this.$router.push({
          name: `${this.setPasswordType}-otp`,
          params: {
            hash: this.hash,
          },
        })
      } catch (error) {
        if (error && error.status === 401) {
          const serverMessage = error.data.errors.Message;
          if(serverMessage) {
            toast.error(this.$t('auth.enter-phone.errors.title'), {
              description: this.$t('auth.enter-phone.errors.invalid_phone_number')
            })
          }

        }  else {
          this.errors.general = 'Помилка надсилання коду. Перевірте номер телефону або спробуйте пізніше.';
        }
      } finally {
        this.isDataLoading = false
      }
    },
  },
}
</script>

<style scoped>
  .login {
    display: flex;
    min-height: min-content;
  }
</style>
